
import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState('Concrete Admixtures');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const productCategories = [
    {
      id: 'concrete-admixtures',
      name: 'Concrete Admixtures',
      icon: 'ri-building-line',
      description: 'Advanced chemical admixtures to enhance concrete performance, workability, and durability for superior construction results.',
      benefits: ['Improved workability', 'Reduced water content', 'Enhanced strength', 'Better durability'],
      technicalInfo: {
        compliance: 'IS 9103, ASTM C494, BS EN 934-2',
        dosage: '0.5% to 2.0% by weight of cement',
        packaging: '50kg, 200kg drums, bulk supply',
        shelfLife: '12 months from date of manufacture'
      },
      products: [
        {
          name: 'Mortar Plasticizer',
          image: 'https://readdy.ai/api/search-image?query=Professional%20concrete%20mortar%20plasticizer%20being%20mixed%20on%20construction%20site%2C%20worker%20adding%20chemical%20additive%20to%20cement%20mortar%2C%20construction%20materials%20improvement%2C%20quality%20concrete%20mixing&width=300&height=200&seq=mortar-1&orientation=landscape',
          description: 'High-performance plasticizer designed to improve workability and reduce water content in mortar applications while maintaining excellent adhesion properties.',
          applications: ['Masonry work', 'Plastering applications', 'Block laying operations', 'Repair mortars', 'Pointing and jointing', 'Tile fixing mortars'],
          features: ['Water reduction up to 15%', 'Improved workability and pumpability', 'Better adhesion to substrates', 'Extended working time', 'Reduced segregation and bleeding', 'Enhanced durability'],
          technicalSpecs: {
            appearance: 'Brown liquid',
            specificGravity: '1.18 ± 0.02',
            chlorideContent: 'Nil',
            airEntrainment: 'Less than 2%'
          }
        },
        {
          name: 'NRWR Plasticisers & Retarders',
          image: 'https://readdy.ai/api/search-image?query=Normal%20range%20water%20reducing%20plasticizer%20with%20retarding%20properties%20being%20added%20to%20concrete%20mix%2C%20construction%20chemical%20admixture%20application&width=300&height=200&seq=nrwr-1&orientation=landscape',
          description: 'Normal range water reducers with retarding properties for controlled setting time, ideal for hot weather concreting and long-distance transportation.',
          applications: ['Hot weather concreting', 'Long distance transport', 'Mass concrete pours', 'Pumped concrete', 'Ready-mix concrete', 'Precast applications'],
          features: ['Water reduction 8-12%', 'Delayed setting time 2-4 hours', 'Better workability retention', 'Reduced bleeding and segregation', 'Improved concrete finish', 'Cost-effective solution'],
          technicalSpecs: {
            appearance: 'Dark brown liquid',
            specificGravity: '1.20 ± 0.02',
            settingTimeDelay: '2-4 hours',
            waterReduction: '8-12%'
          }
        },
        {
          name: 'HRWR Plasticisers',
          image: 'https://readdy.ai/api/search-image?query=High%20range%20water%20reducing%20superplasticizer%20being%20added%20to%20concrete%20mixer%2C%20flowing%20concrete%20with%20improved%20workability%2C%20construction%20chemical%20admixture%20application&width=300&height=200&seq=hrwr-1&orientation=landscape',
          description: 'High-range water reducers (superplasticizers) for superior concrete performance, enabling production of high-strength, flowing concrete.',
          applications: ['High-strength concrete', 'Self-compacting concrete', 'Precast elements', 'Ready-mix concrete', 'Architectural concrete', 'Bridge construction'],
          features: ['Water reduction up to 25%', 'High strength gain', 'Better flowability and pumpability', 'Reduced segregation', 'Enhanced durability', 'Improved surface finish'],
          technicalSpecs: {
            appearance: 'Light brown liquid',
            specificGravity: '1.08 ± 0.02',
            waterReduction: '20-25%',
            strengthIncrease: '15-25%'
          }
        },
        {
          name: 'Hyperplasticiser',
          image: 'https://readdy.ai/api/search-image?query=Ultra-high%20performance%20hyperplasticizer%20for%20advanced%20concrete%20applications%2C%20premium%20concrete%20admixture%20for%20specialized%20construction%20projects&width=300&height=200&seq=hyper-1&orientation=landscape',
          description: 'Ultra-high performance plasticizers for specialized applications requiring exceptional strength and workability characteristics.',
          applications: ['Ultra-high strength concrete', 'Architectural concrete', 'Precast prestressed elements', 'Special structures', 'High-performance applications', 'Critical infrastructure'],
          features: ['Water reduction up to 40%', 'Exceptional strength development', 'Superior finish quality', 'Enhanced durability properties', 'Reduced permeability', 'Extended service life'],
          technicalSpecs: {
            appearance: 'Pale yellow liquid',
            specificGravity: '1.06 ± 0.02',
            waterReduction: '35-40%',
            strengthIncrease: '25-40%'
          }
        },
        {
          name: 'Air Entertainers & Foaming Agents',
          image: 'https://readdy.ai/api/search-image?query=Air%20entraining%20agent%20being%20added%20to%20concrete%20for%20freeze-thaw%20resistance%2C%20foaming%20agent%20application%20in%20lightweight%20concrete%20production&width=300&height=200&seq=air-1&orientation=landscape',
          description: 'Specialized agents to create controlled air voids for freeze-thaw resistance and lightweight concrete production with consistent air content.',
          applications: ['Freeze-thaw zones', 'Lightweight concrete', 'Cellular concrete', 'Insulation applications', 'Precast elements', 'Cold climate construction'],
          features: ['Controlled air content 4-8%', 'Freeze-thaw resistance', 'Reduced density up to 30%', 'Improved workability', 'Enhanced thermal properties', 'Stable air void system'],
          technicalSpecs: {
            appearance: 'Clear to pale yellow liquid',
            specificGravity: '1.02 ± 0.02',
            airContent: '4-8%',
            foamStability: 'Excellent'
          }
        },
        {
          name: 'Integral Waterproofing',
          image: 'https://readdy.ai/api/search-image?query=Integral%20waterproofing%20admixture%20being%20mixed%20into%20concrete%20for%20water%20resistance%2C%20crystalline%20waterproofing%20technology%20application&width=300&height=200&seq=integral-1&orientation=landscape',
          description: 'Built-in waterproofing protection for concrete structures using crystalline technology that provides permanent water resistance.',
          applications: ['Basements and foundations', 'Water tanks and reservoirs', 'Swimming pools', 'Underground structures', 'Marine construction', 'Tunnels and subways'],
          features: ['Permanent waterproofing', 'Self-healing properties', 'Reduced permeability by 90%', 'Chemical resistance', 'Non-toxic formulation', 'Long-term effectiveness'],
          technicalSpecs: {
            appearance: 'White crystalline powder',
            dosage: '0.8-2.0% by weight of cement',
            permeabilityReduction: 'Up to 90%',
            selfHealing: 'Cracks up to 0.4mm'
          }
        },
        {
          name: 'Accelerators & Antifreeze',
          image: 'https://readdy.ai/api/search-image?query=Concrete%20accelerator%20and%20antifreeze%20admixture%20for%20cold%20weather%20construction%2C%20winter%20concreting%20chemical%20application&width=300&height=200&seq=accel-2&orientation=landscape',
          description: 'Advanced formulations to speed up setting time and protect against freezing in cold weather conditions while maintaining concrete quality.',
          applications: ['Cold weather concreting', 'Emergency repairs', 'Winter construction', 'Quick turnaround projects', 'Precast production', 'Shotcrete applications'],
          features: ['Faster setting time by 50%', 'Freeze protection down to -10°C', 'Early strength development', 'Extended working season', 'Reduced bleeding', 'Improved early age properties'],
          technicalSpecs: {
            appearance: 'Clear to light yellow liquid',
            specificGravity: '1.15 ± 0.02',
            settingTimeReduction: '30-50%',
            freezeProtection: 'Down to -10°C'
          }
        },
        {
          name: 'Concrete Fibers',
          image: 'https://readdy.ai/api/search-image?query=Various%20concrete%20reinforcement%20fibers%20including%20steel%2C%20polypropylene%20and%20glass%20fibers%20for%20concrete%20reinforcement%20applications&width=300&height=200&seq=fibers-1&orientation=landscape',
          description: 'High-performance reinforcement fibers including steel, polypropylene, and glass fibers for enhanced concrete performance and crack control.',
          applications: ['Industrial floors', 'Shotcrete applications', 'Precast elements', 'Crack control', 'Impact-resistant structures', 'Tunnel linings'],
          features: ['Crack resistance improvement', 'Impact resistance enhancement', 'Reduced shrinkage cracking', 'Enhanced toughness', 'Improved fatigue resistance', 'Easy mixing and placement'],
          technicalSpecs: {
            fiberTypes: 'Steel, Polypropylene, Glass',
            length: '6-60mm depending on type',
            aspectRatio: '45-80',
            dosage: '0.5-2.0% by volume'
          }
        }
      ]
    },
    {
      id: 'surface-treatments',
      name: 'Surface Treatments',
      icon: 'ri-paint-brush-line',
      description: 'Specialized surface treatment solutions for concrete protection, enhancement, and preparation for various finishing applications.',
      benefits: ['Surface protection', 'Enhanced durability', 'Improved aesthetics', 'Easy maintenance'],
      technicalInfo: {
        compliance: 'ASTM C309, IS 2645, BS 8110',
        coverage: '4-6 m²/liter depending on surface',
        packaging: '20L, 200L drums',
        shelfLife: '12 months in original packaging'
      },
      products: [
        {
          name: 'Surface Retarders',
          image: 'https://readdy.ai/api/search-image?query=Surface%20retarder%20application%20on%20fresh%20concrete%20for%20exposed%20aggregate%20finish%2C%20decorative%20concrete%20surface%20treatment&width=300&height=200&seq=retarder-1&orientation=landscape',
          description: 'Specialized chemical retarders applied to fresh concrete surfaces to create exposed aggregate finishes and textured surfaces with controlled depth.',
          applications: ['Exposed aggregate finishes', 'Architectural concrete', 'Decorative finishes', 'Non-slip surfaces', 'Precast panels', 'Pavement texturing'],
          features: ['Controlled exposure depth 1-3mm', 'Uniform aggregate exposure', 'Easy application by spray', 'Weather resistant formulation', 'No staining of aggregates', 'Consistent results'],
          technicalSpecs: {
            appearance: 'Clear to pale yellow liquid',
            coverage: '4-6 m²/liter',
            exposureDepth: '1-3mm',
            applicationMethod: 'Spray or brush'
          }
        },
        {
          name: 'Curing Compounds',
          image: 'https://readdy.ai/api/search-image?query=Professional%20application%20of%20concrete%20curing%20compound%20on%20fresh%20concrete%20surface%2C%20worker%20spraying%20curing%20agent%2C%20concrete%20surface%20protection%20treatment&width=300&height=200&seq=cure-1&orientation=landscape',
          description: 'High-performance membrane-forming curing compounds that ensure proper concrete hydration and strength development by retaining moisture.',
          applications: ['Concrete slabs and pavements', 'Industrial floors', 'Precast elements', 'Bridge decks', 'Airport runways', 'Mass concrete structures'],
          features: ['Moisture retention efficiency >95%', 'UV resistant formulation', 'Easy spray application', 'Non-yellowing formula', 'Excellent film formation', 'Meets international standards'],
          technicalSpecs: {
            appearance: 'White emulsion',
            coverage: '5-7 m²/liter',
            moistureRetention: '>95%',
            filmThickness: '25-50 microns'
          }
        },
        {
          name: 'Release Agents',
          image: 'https://readdy.ai/api/search-image?query=Concrete%20release%20agent%20application%20on%20formwork%20for%20easy%20demolding%2C%20form%20release%20oil%20being%20applied%20to%20concrete%20molds&width=300&height=200&seq=release-1&orientation=landscape',
          description: 'Advanced release agents that prevent concrete adhesion to formwork and molds while ensuring excellent surface quality and easy demolding.',
          applications: ['Formwork release', 'Precast production', 'Architectural concrete', 'Complex shaped elements', 'Tilt-up construction', 'Decorative panels'],
          features: ['Easy demolding without damage', 'Excellent surface quality', 'Stain-free concrete finish', 'Multiple use capability', 'Environmentally safe', 'Reduces cleaning time'],
          technicalSpecs: {
            appearance: 'Clear to amber liquid',
            coverage: '15-25 m²/liter',
            flashPoint: '>60°C',
            viscosity: '20-40 cSt at 40°C'
          }
        }
      ]
    },
    {
      id: 'grouts-anchors',
      name: 'Grouts & Anchors',
      icon: 'ri-tools-fill',
      description: 'High-performance grouting and anchoring solutions for structural applications requiring superior strength and reliability.',
      benefits: ['High strength', 'Non-shrink properties', 'Easy installation', 'Long-term reliability'],
      technicalInfo: {
        compliance: 'ASTM C1107, IS 6909, BS EN 445',
        compressiveStrength: '40-80 MPa at 28 days',
        packaging: '25kg bags, 1000kg bulk bags',
        shelfLife: '12 months in dry conditions'
      },
      products: [
        {
          name: 'Grout Additives & Admixtures',
          image: 'https://readdy.ai/api/search-image?query=Grout%20additives%20and%20admixtures%20being%20mixed%20for%20enhanced%20performance%2C%20construction%20chemical%20additives%20for%20grouting%20applications&width=300&height=200&seq=grout-add-1&orientation=landscape',
          description: 'Specialized additives and admixtures designed to enhance grout performance characteristics for specific application requirements.',
          applications: ['Modified grout systems', 'Special performance requirements', 'Custom formulations', 'Enhanced flow properties', 'Extended working time', 'Improved adhesion'],
          features: ['Improved flow characteristics', 'Enhanced bond strength', 'Reduced shrinkage', 'Better workability', 'Extended pot life', 'Customizable properties'],
          technicalSpecs: {
            appearance: 'Various (powder/liquid)',
            dosage: '0.5-3.0% by weight',
            flowIncrease: '15-30%',
            shrinkageReduction: 'Up to 50%'
          }
        },
        {
          name: 'Cementitious Grouts',
          image: 'https://readdy.ai/api/search-image?query=Non-shrink%20cementitious%20grout%20being%20poured%20for%20structural%20support%2C%20construction%20worker%20applying%20grout%20mixture%2C%20foundation%20grouting%20work&width=300&height=200&seq=cement-1&orientation=landscape',
          description: 'Non-shrink, high-strength cementitious grouts for general construction applications requiring reliable load transfer and void filling.',
          applications: ['Column base plates', 'Precast connections', 'Bearing pad grouting', 'Void filling', 'Machine foundations', 'Structural connections'],
          features: ['Non-shrink formulation', 'High flow characteristics', 'Easy placement and finishing', 'Economical solution', 'Good bond strength', 'Consistent quality'],
          technicalSpecs: {
            appearance: 'Grey powder',
            compressiveStrength: '40-50 MPa at 28 days',
            flowability: '110-130% (flow table)',
            shrinkage: 'Nil to slight expansion'
          }
        },
        {
          name: 'Epoxy Grouts',
          image: 'https://readdy.ai/api/search-image?query=High-strength%20epoxy%20grout%20application%20for%20machinery%20foundations%2C%20precision%20grouting%20work%2C%20structural%20anchoring%20with%20epoxy%20materials&width=300&height=200&seq=epoxy-1&orientation=landscape',
          description: 'Ultra-high strength epoxy-based grouts for precision grouting applications requiring exceptional load-bearing capacity and chemical resistance.',
          applications: ['Machinery foundations', 'Anchor bolt installation', 'Precision equipment mounting', 'Heavy equipment foundations', 'Chemical plant applications', 'High-load connections'],
          features: ['Exceptional compressive strength >80 MPa', 'Chemical resistance', 'Non-shrink properties', 'Vibration resistance', 'Excellent adhesion', 'Long service life'],
          technicalSpecs: {
            appearance: 'Grey paste',
            compressiveStrength: '80-100 MPa at 28 days',
            chemicalResistance: 'Excellent',
            workingTime: '45-60 minutes at 25°C'
          }
        },
        {
          name: 'Anchor Grouts',
          image: 'https://readdy.ai/api/search-image?query=Specialized%20anchor%20grout%20for%20post-installed%20anchoring%20systems%2C%20high-performance%20grouting%20for%20structural%20connections&width=300&height=200&seq=anchor-grout-1&orientation=landscape',
          description: 'Specialized high-performance grouts specifically formulated for anchoring applications with rapid strength development and superior bond.',
          applications: ['Post-installed anchors', 'Structural connections', 'Retrofit applications', 'Heavy load fixings', 'Seismic retrofitting', 'Equipment anchoring'],
          features: ['High bond strength >25 MPa', 'Fast setting 2-4 hours', 'Excellent load transfer', 'Seismic resistance', 'Easy injection', 'Reliable performance'],
          technicalSpecs: {
            appearance: 'Light grey powder',
            bondStrength: '>25 MPa',
            settingTime: '2-4 hours',
            workingTime: '15-20 minutes'
          }
        }
      ]
    },
    {
      id: 'concrete-repair',
      name: 'Concrete Repair',
      icon: 'ri-hammer-line',
      description: 'Comprehensive concrete repair and restoration solutions for structural integrity and extended service life.',
      benefits: ['Structural integrity', 'Extended service life', 'Cost-effective repairs', 'Proven performance'],
      technicalInfo: {
        compliance: 'ASTM C928, IS 13620, BS EN 1504',
        bondStrength: '>2.0 MPa',
        packaging: '25kg bags, custom packaging available',
        shelfLife: '12 months in original packaging'
      },
      products: [
        {
          name: 'Cementitious Repair Products',
          image: 'https://readdy.ai/api/search-image?query=Cementitious%20repair%20mortar%20application%20on%20damaged%20concrete%20structure%2C%20structural%20concrete%20restoration%20with%20repair%20materials&width=300&height=200&seq=cement-repair-1&orientation=landscape',
          description: 'High-performance cement-based repair mortars for structural restoration with excellent bond strength and durability characteristics.',
          applications: ['Spalling repair', 'Concrete patching', 'Structural restoration', 'Surface repairs', 'Column repairs', 'Beam rehabilitation'],
          features: ['High bond strength >2.5 MPa', 'Shrinkage compensated', 'Weather resistant', 'Easy application', 'Excellent adhesion', 'Durable finish'],
          technicalSpecs: {
            appearance: 'Grey powder',
            compressiveStrength: '35-45 MPa at 28 days',
            bondStrength: '>2.5 MPa',
            shrinkage: 'Compensated'
          }
        },
        {
          name: 'Steel Reinforcement & Anti-Corrosion Protection',
          image: 'https://readdy.ai/api/search-image?query=Anti-corrosion%20treatment%20application%20on%20steel%20reinforcement%20in%20concrete%2C%20rebar%20protection%20coating%2C%20construction%20corrosion%20prevention%20measures&width=300&height=200&seq=corr-1&orientation=landscape',
          description: 'Advanced corrosion protection systems for steel reinforcement including migrating corrosion inhibitors and protective coatings.',
          applications: ['Marine structures', 'Parking garages', 'Bridge decks', 'Industrial facilities', 'Coastal construction', 'Chloride-contaminated structures'],
          features: ['Migrating corrosion inhibitor', 'Penetrating formula', 'Long-term protection >20 years', 'Environmentally safe', 'Easy application', 'Cost-effective'],
          technicalSpecs: {
            appearance: 'Clear liquid',
            penetration: '10-25mm',
            coverage: '3-5 m²/liter',
            protectionPeriod: '>20 years'
          }
        },
        {
          name: 'Epoxy Repair Products',
          image: 'https://readdy.ai/api/search-image?query=High-strength%20epoxy%20repair%20system%20application%20on%20concrete%20structure%2C%20structural%20epoxy%20repair%20materials%20for%20concrete%20restoration&width=300&height=200&seq=epoxy-repair-1&orientation=landscape',
          description: 'Ultra-high performance epoxy-based repair systems for structural repairs requiring exceptional strength and chemical resistance.',
          applications: ['Structural repairs', 'Load-bearing repairs', 'Chemical resistant repairs', 'Underwater repairs', 'Emergency repairs', 'Critical infrastructure'],
          features: ['Superior strength >60 MPa', 'Chemical resistance', 'Excellent adhesion >3.0 MPa', 'Durable finish', 'Fast curing', 'Versatile application'],
          technicalSpecs: {
            appearance: 'Grey paste',
            compressiveStrength: '60-80 MPa',
            bondStrength: '>3.0 MPa',
            chemicalResistance: 'Excellent'
          }
        },
        {
          name: 'Injection Products',
          image: 'https://readdy.ai/api/search-image?query=Crack%20injection%20system%20for%20concrete%20repair%2C%20epoxy%20injection%20into%20structural%20cracks%2C%20professional%20concrete%20crack%20sealing%20work&width=300&height=200&seq=injection-1&orientation=landscape',
          description: 'Specialized low-viscosity injection systems for crack repair, void filling, and structural strengthening applications.',
          applications: ['Crack sealing', 'Void filling', 'Structural strengthening', 'Water leakage repair', 'Honeycomb repair', 'Joint sealing'],
          features: ['Low viscosity for deep penetration', 'High bond strength', 'Structural bonding capability', 'Permanent repair solution', 'Easy injection', 'Reliable performance'],
          technicalSpecs: {
            appearance: 'Clear to amber liquid',
            viscosity: '200-500 cP',
            bondStrength: '>2.5 MPa',
            gelTime: '5-45 minutes (adjustable)'
          }
        }
      ]
    },
    {
      id: 'flooring-systems',
      name: 'Flooring Systems',
      icon: 'ri-home-4-line',
      description: 'Industrial and commercial flooring solutions for demanding environments with superior performance characteristics.',
      benefits: ['Chemical resistance', 'Durability', 'Easy maintenance', 'Attractive finish'],
      technicalInfo: {
        compliance: 'ASTM C779, IS 5640, BS 8204',
        wearResistance: 'AR1-AR4 classification',
        packaging: 'Various sizes available',
        shelfLife: '12-24 months depending on product'
      },
      products: [
        {
          name: 'Dry Shake Hardeners & Powder Release Agents',
          image: 'https://readdy.ai/api/search-image?query=Dry%20shake%20hardener%20application%20on%20fresh%20concrete%20floor%2C%20metallic%20aggregate%20hardener%20being%20applied%20to%20industrial%20flooring&width=300&height=200&seq=dry-shake-1&orientation=landscape',
          description: 'Metallic and non-metallic dry shake hardeners for creating wear-resistant industrial floor surfaces with enhanced durability.',
          applications: ['Warehouses', 'Manufacturing facilities', 'Heavy traffic areas', 'Industrial floors', 'Loading docks', 'Distribution centers'],
          features: ['Increased abrasion resistance AR4', 'Reduced dusting', 'Enhanced durability', 'Decorative color options', 'Easy application', 'Cost-effective'],
          technicalSpecs: {
            appearance: 'Metallic/colored powder',
            coverage: '3-5 kg/m²',
            abrasionResistance: 'AR4 classification',
            colors: 'Grey, green, red, blue'
          }
        },
        {
          name: 'Liquid Hardeners',
          image: 'https://readdy.ai/api/search-image?query=Liquid%20concrete%20hardener%20application%20on%20industrial%20floor%20surface%2C%20penetrating%20hardener%20treatment%20for%20concrete%20densification&width=300&height=200&seq=liquid-hard-1&orientation=landscape',
          description: 'Penetrating liquid hardeners for concrete densification and surface hardening of existing and new concrete floors.',
          applications: ['Existing concrete floors', 'Polished concrete preparation', 'Dust reduction', 'Surface densification', 'Warehouse floors', 'Retail spaces'],
          features: ['Deep penetration up to 5mm', 'Permanent hardening', 'Dust-free surface', 'Easy maintenance', 'Increased wear resistance', 'Environmentally friendly'],
          technicalSpecs: {
            appearance: 'Clear liquid',
            coverage: '3-5 m²/liter',
            penetration: 'Up to 5mm',
            hardnessIncrease: '25-40%'
          }
        },
        {
          name: 'Flooring System Sealers',
          image: 'https://readdy.ai/api/search-image?query=Floor%20sealer%20application%20on%20concrete%20surface%2C%20protective%20sealing%20system%20for%20industrial%20flooring%2C%20glossy%20floor%20finish&width=300&height=200&seq=floor-seal-1&orientation=landscape',
          description: 'High-performance protective sealers for flooring systems providing chemical resistance and enhanced appearance.',
          applications: ['Concrete floors', 'Decorative surfaces', 'High-traffic areas', 'Chemical exposure areas', 'Food processing plants', 'Pharmaceutical facilities'],
          features: ['Chemical resistance', 'Stain protection', 'Easy cleaning', 'Enhanced appearance', 'UV stability', 'Long service life'],
          technicalSpecs: {
            appearance: 'Clear to amber liquid',
            coverage: '6-8 m²/liter',
            dryingTime: '4-6 hours',
            recoatTime: '12-24 hours'
          }
        },
        {
          name: 'Cementitious Flooring Systems',
          image: 'https://readdy.ai/api/search-image?query=Cementitious%20flooring%20system%20installation%20in%20industrial%20facility%2C%20self-leveling%20cement%20floor%20application&width=300&height=200&seq=cement-floor-1&orientation=landscape',
          description: 'Self-leveling cementitious flooring systems for creating smooth, level surfaces in industrial and commercial applications.',
          applications: ['Industrial facilities', 'Commercial spaces', 'Underlayment', 'Renovation projects', 'Office buildings', 'Retail spaces'],
          features: ['Self-leveling properties', 'Rapid setting 2-4 hours', 'High strength', 'Smooth finish', 'Easy application', 'Excellent adhesion'],
          technicalSpecs: {
            appearance: 'Grey powder',
            compressiveStrength: '25-35 MPa',
            flowability: 'Self-leveling',
            thickness: '3-50mm'
          }
        },
        {
          name: 'Epoxy Flooring Systems',
          image: 'https://readdy.ai/api/search-image?query=Industrial%20epoxy%20floor%20coating%20application%20in%20warehouse%20facility%2C%20smooth%20glossy%20epoxy%20surface%2C%20professional%20flooring%20installation%20work&width=300&height=200&seq=epoxy-floor-1&orientation=landscape',
          description: 'High-performance epoxy flooring systems providing seamless, chemical-resistant surfaces for demanding industrial environments.',
          applications: ['Manufacturing facilities', 'Warehouses', 'Food processing plants', 'Pharmaceutical facilities', 'Laboratories', 'Clean rooms'],
          features: ['Chemical resistance', 'Seamless finish', 'Easy cleaning and maintenance', 'Slip resistance options', 'Decorative possibilities', 'Long service life >15 years'],
          technicalSpecs: {
            appearance: 'Various colors available',
            thickness: '2-5mm',
            chemicalResistance: 'Excellent',
            serviceLife: '>15 years'
          }
        },
        {
          name: 'Polyurethane Flooring Systems',
          image: 'https://readdy.ai/api/search-image?query=Polyurethane%20flooring%20installation%20in%20commercial%20space%2C%20flexible%20floor%20coating%20application%2C%20modern%20industrial%20flooring%20system&width=300&height=200&seq=pu-floor-1&orientation=landscape',
          description: 'Flexible polyurethane flooring systems offering excellent thermal shock resistance and flexibility for demanding applications.',
          applications: ['Cold storage facilities', 'Food industry', 'Healthcare facilities', 'Commercial kitchens', 'Freezer areas', 'Temperature-varying environments'],
          features: ['Thermal shock resistance -40°C to +120°C', 'Flexible coating', 'FDA approved formulations', 'Anti-bacterial properties', 'Easy cleaning', 'Slip resistance'],
          technicalSpecs: {
            appearance: 'Various colors',
            temperatureRange: '-40°C to +120°C',
            thickness: '4-9mm',
            flexibility: 'Excellent'
          }
        },
        {
          name: 'Vehicle Decking Systems',
          image: 'https://readdy.ai/api/search-image?query=Vehicle%20decking%20system%20installation%20in%20parking%20garage%2C%20heavy-duty%20flooring%20for%20vehicle%20traffic%2C%20automotive%20flooring%20application&width=300&height=200&seq=vehicle-deck-1&orientation=landscape',
          description: 'Heavy-duty flooring systems specifically designed for vehicle traffic with superior load-bearing capacity and durability.',
          applications: ['Parking garages', 'Service stations', 'Loading docks', 'Vehicle maintenance areas', 'Car dealerships', 'Airport hangars'],
          features: ['Heavy load capacity >500 kg/cm²', 'Slip resistance', 'Chemical resistance to oils', 'Easy maintenance', 'Crack bridging ability', 'Weather resistance'],
          technicalSpecs: {
            appearance: 'Grey or colored',
            loadCapacity: '>500 kg/cm²',
            thickness: '3-6mm',
            skidResistance: 'Class 3'
          }
        },
        {
          name: 'Static Controlled Flooring Systems',
          image: 'https://readdy.ai/api/search-image?query=Anti-static%20flooring%20installation%20in%20electronics%20manufacturing%20facility%2C%20ESD-safe%20floor%20coating%2C%20specialized%20industrial%20flooring%20for%20sensitive%20environments&width=300&height=200&seq=static-1&orientation=landscape',
          description: 'ESD-safe flooring systems for environments requiring static electricity control and protection of sensitive electronic equipment.',
          applications: ['Electronics manufacturing', 'Clean rooms', 'Server rooms', 'Laboratories', 'Pharmaceutical production', 'Aerospace facilities'],
          features: ['Static dissipative properties', 'Conductive options available', 'Dust-free finish', 'Easy maintenance', 'Chemical resistance', 'Long-term conductivity'],
          technicalSpecs: {
            appearance: 'Various colors',
            surfaceResistance: '10⁶-10⁹ ohms',
            thickness: '2-4mm',
            conductivity: 'Permanent'
          }
        }
      ]
    },
    {
      id: 'protective-coatings',
      name: 'Protective Coatings',
      icon: 'ri-palette-line',
      description: 'Advanced protective coating systems for harsh environments providing long-term protection and enhanced performance.',
      benefits: ['Corrosion protection', 'Chemical resistance', 'Extended service life', 'Easy maintenance'],
      technicalInfo: {
        compliance: 'ASTM D6132, IS 5410, BS EN 1504-2',
        serviceLife: '15-25 years',
        packaging: '20L, 200L containers',
        shelfLife: '24 months in original packaging'
      },
      products: [
        {
          name: 'Acrylic and Anti-Carbonation Coatings',
          image: 'https://readdy.ai/api/search-image?query=Anti-carbonation%20coating%20application%20on%20concrete%20building%20facade%2C%20protective%20coating%20system%2C%20building%20preservation%20treatment%20work&width=300&height=200&seq=carbon-1&orientation=landscape',
          description: 'High-performance acrylic coatings providing effective barrier against carbonation while maintaining breathability of concrete substrates.',
          applications: ['Building facades', 'Parking structures', 'Marine environments', 'Industrial buildings', 'Bridges', 'Infrastructure protection'],
          features: ['CO₂ barrier', 'Breathable system', 'UV resistant formulation', 'Crack bridging up to 0.2mm', 'Weather resistance', 'Easy application'],
          technicalSpecs: {
            appearance: 'White/colored liquid',
            coverage: '6-8 m²/liter',
            co2Resistance: '>50 years protection',
            crackBridging: 'Up to 0.2mm'
          }
        },
        {
          name: 'Polyurethane Coatings',
          image: 'https://readdy.ai/api/search-image?query=Polyurethane%20protective%20coating%20application%20on%20industrial%20structure%2C%20weather-resistant%20coating%20system%20for%20harsh%20environments&width=300&height=200&seq=pu-coat-1&orientation=landscape',
          description: 'Flexible polyurethane coatings offering superior weather resistance and flexibility for structures subject to movement.',
          applications: ['Exterior structures', 'Marine environments', 'Industrial equipment', 'Bridge protection', 'Coastal structures', 'Chemical plants'],
          features: ['Excellent weather resistance', 'High flexibility and elongation', 'Chemical resistance', 'Long service life >20 years', 'UV stability', 'Self-cleaning properties'],
          technicalSpecs: {
            appearance: 'Various colors',
            elongation: '>200%',
            coverage: '4-6 m²/liter',
            serviceLife: '>20 years'
          }
        },
        {
          name: 'Epoxy Coatings',
          image: 'https://readdy.ai/api/search-image?query=High-performance%20epoxy%20coating%20application%20on%20industrial%20equipment%2C%20chemical-resistant%20protective%20coating%20system&width=300&height=200&seq=epoxy-coat-1&orientation=landscape',
          description: 'High-performance epoxy coatings providing exceptional chemical resistance and mechanical strength for industrial applications.',
          applications: ['Chemical plants', 'Storage tanks', 'Industrial equipment', 'Pipelines', 'Water treatment plants', 'Manufacturing facilities'],
          features: ['Excellent chemical resistance', 'High adhesion strength', 'Mechanical strength', 'Easy application', 'Smooth finish', 'Cost-effective'],
          technicalSpecs: {
            appearance: 'Various colors',
            chemicalResistance: 'Excellent',
            adhesion: '>5 MPa',
            thickness: '150-300 microns'
          }
        },
        {
          name: 'Water Repellent Coatings',
          image: 'https://readdy.ai/api/search-image?query=Water%20repellent%20coating%20application%20on%20building%20exterior%2C%20hydrophobic%20surface%20treatment%20for%20water%20protection&width=300&height=200&seq=water-rep-1&orientation=landscape',
          description: 'Invisible hydrophobic coatings providing excellent water repellency while maintaining the natural appearance of substrates.',
          applications: ['Building exteriors', 'Natural stone protection', 'Concrete surfaces', 'Historic buildings', 'Facades', 'Masonry protection'],
          features: ['Excellent water repellency', 'Breathable system', 'Invisible protection', 'Stain resistance', 'Easy application', 'Long-lasting effect'],
          technicalSpecs: {
            appearance: 'Clear liquid',
            waterAbsorption: '<5% reduction',
            coverage: '4-8 m²/liter',
            penetration: '2-5mm'
          }
        }
      ]
    },
    {
      id: 'sealants-joints',
      name: 'Sealants & Joints',
      icon: 'ri-scissors-cut-line',
      description: 'Professional sealing solutions for construction joints and connections with superior weather resistance and durability.',
      benefits: ['Weather resistance', 'Movement accommodation', 'Easy application', 'Long service life'],
      technicalInfo: {
        compliance: 'ASTM C920, IS 13343, BS EN 15651',
        movementCapability: '±25% joint width',
        packaging: '300ml cartridges, 600ml sausages',
        shelfLife: '12-18 months'
      },
      products: [
        {
          name: 'Acrylic Sealants',
          image: 'https://readdy.ai/api/search-image?query=Acrylic%20sealant%20application%20on%20building%20joints%2C%20paintable%20sealant%20for%20interior%20and%20exterior%20use&width=300&height=200&seq=acrylic-seal-1&orientation=landscape',
          description: 'Paintable acrylic sealants for general construction applications offering good adhesion and easy application characteristics.',
          applications: ['Window and door frames', 'Interior joints', 'General sealing applications', 'Crack sealing', 'Perimeter sealing', 'Non-structural glazing'],
          features: ['Paintable finish', 'Easy application and tooling', 'Good adhesion to most substrates', 'Cost-effective solution', 'Low odor formulation', 'UV resistant'],
          technicalSpecs: {
            appearance: 'White/colored paste',
            movement: '±12.5%',
            skinningTime: '10-20 minutes',
            cureTime: '24-48 hours'
          }
        },
        {
          name: 'Silicone Sealants',
          image: 'https://readdy.ai/api/search-image?query=Professional%20silicone%20sealant%20application%20on%20glazing%20system%2C%20weather-resistant%20building%20sealant%20work&width=300&height=200&seq=silicone-1&orientation=landscape',
          description: 'High-performance silicone sealants for demanding applications requiring superior weather resistance and movement capability.',
          applications: ['Curtain wall glazing', 'Structural glazing', 'Sanitary applications', 'Weather sealing', 'Expansion joints', 'Perimeter sealing'],
          features: ['Excellent adhesion without primer', 'Superior weather resistance', 'UV stable formulation', 'Long service life >20 years', 'High movement capability', 'Mold resistant'],
          technicalSpecs: {
            appearance: 'Various colors',
            movement: '±25%',
            skinningTime: '5-15 minutes',
            serviceLife: '>20 years'
          }
        },
        {
          name: 'Civil & Pavement Sealants',
          image: 'https://readdy.ai/api/search-image?query=Pavement%20joint%20sealing%20with%20specialized%20sealant%2C%20road%20construction%20joint%20sealing%20work%2C%20civil%20engineering%20sealant%20application&width=300&height=200&seq=civil-seal-1&orientation=landscape',
          description: 'Specialized heavy-duty sealants for civil engineering applications including pavements, runways, and infrastructure projects.',
          applications: ['Pavement joints', 'Bridge joints', 'Airport runways', 'Highway construction', 'Concrete pavements', 'Industrial flooring joints'],
          features: ['Traffic resistance', 'Fuel and chemical resistance', 'Temperature cycling resistance', 'Heavy duty performance', 'Self-leveling properties', 'Long service life'],
          technicalSpecs: {
            appearance: 'Black/grey',
            movement: '±25%',
            trafficResistance: 'Excellent',
            temperatureRange: '-40°C to +80°C'
          }
        },
        {
          name: 'Joint Fillers, Covers & Accessories',
          image: 'https://readdy.ai/api/search-image?query=Joint%20filler%20and%20cover%20installation%20in%20concrete%20structure%2C%20expansion%20joint%20accessories%20and%20sealing%20systems&width=300&height=200&seq=joint-fill-1&orientation=landscape',
          description: 'Complete joint sealing systems including fillers, covers, and accessories for comprehensive joint protection solutions.',
          applications: ['Expansion joints', 'Construction joints', 'Movement joints', 'Seismic joints', 'Building facades', 'Infrastructure projects'],
          features: ['Complete sealing systems', 'Easy installation', 'Movement accommodation', 'Weather protection', 'Durable materials', 'Custom solutions available'],
          technicalSpecs: {
            materials: 'EPDM, PVC, Metal',
            movement: 'Up to ±50mm',
            temperatureRange: '-40°C to +80°C',
            installation: 'Mechanical fixing'
          }
        }
      ]
    },
    {
      id: 'waterproofing',
      name: 'Waterproofing',
      icon: 'ri-drop-line',
      description: 'Complete waterproofing solutions for buildings and infrastructure providing reliable protection against water ingress.',
      benefits: ['Complete water barrier', 'Durable protection', 'Versatile application', 'Proven technology'],
      technicalInfo: {
        compliance: 'ASTM D6134, IS 3462, BS 8102',
        waterResistance: 'Hydrostatic pressure >10m',
        packaging: 'Various sizes available',
        shelfLife: '12-24 months depending on product'
      },
      products: [
        {
          name: 'Bituminous Damp & Waterproofing',
          image: 'https://readdy.ai/api/search-image?query=Bituminous%20waterproofing%20membrane%20application%20on%20foundation%2C%20hot-applied%20bitumen%20waterproofing%20system%20installation&width=300&height=200&seq=bitumen-1&orientation=landscape',
          description: 'Traditional bituminous waterproofing systems providing reliable protection for foundations and below-grade structures.',
          applications: ['Foundation waterproofing', 'Basement protection', 'Roof waterproofing', 'Below-grade structures', 'Retaining walls', 'Tunnels'],
          features: ['Proven technology >50 years', 'Cost effective solution', 'Easy application', 'Good adhesion to substrates', 'Self-healing properties', 'Chemical resistance'],
          technicalSpecs: {
            appearance: 'Black liquid/paste',
            coverage: '1.5-2.5 kg/m²',
            waterResistance: '>5m head',
            temperatureRange: '-20°C to +80°C'
          }
        },
        {
          name: 'Cementitious Waterproofing',
          image: 'https://readdy.ai/api/search-image?query=Cementitious%20waterproofing%20application%20on%20concrete%20surface%2C%20cement-based%20waterproofing%20system%20for%20basements&width=300&height=200&seq=cement-water-1&orientation=landscape',
          description: 'Cement-based waterproofing systems offering breathable protection ideal for positive water pressure applications.',
          applications: ['Basements and foundations', 'Water tanks and reservoirs', 'Swimming pools', 'Wet areas and bathrooms', 'Tunnels', 'Underground structures'],
          features: ['Breathable waterproof system', 'Easy brush/spray application', 'Good for positive pressure', 'Economical solution', 'Non-toxic formulation', 'Excellent adhesion'],
          technicalSpecs: {
            appearance: 'Grey/white powder',
            coverage: '1.5-2.0 kg/m²',
            waterResistance: '>7 bar pressure',
            breathability: 'Vapor permeable'
          }
        },
        {
          name: 'Acrylic Waterproofing',
          image: 'https://readdy.ai/api/search-image?query=Acrylic%20waterproofing%20membrane%20application%20on%20roof%20surface%2C%20liquid%20waterproofing%20coating%20system%20installation&width=300&height=200&seq=acrylic-water-1&orientation=landscape',
          description: 'Flexible acrylic waterproofing membranes providing seamless protection with excellent crack-bridging capabilities.',
          applications: ['Roof waterproofing', 'Balconies and terraces', 'Exterior walls', 'Podium decks', 'Planter boxes', 'Wet areas'],
          features: ['UV resistance', 'Crack bridging up to 2mm', 'Easy maintenance', 'Decorative color options', 'Seamless application', 'Long service life >15 years'],
          technicalSpecs: {
            appearance: 'White/colored liquid',
            coverage: '1.5-2.0 L/m²',
            elongation: '>300%',
            crackBridging: 'Up to 2mm'
          }
        },
        {
          name: 'Waterstops',
          image: 'https://readdy.ai/api/search-image?query=Waterstop%20installation%20in%20concrete%20construction%20joint%2C%20PVC%20waterstop%20for%20water%20barrier%20in%20structures&width=300&height=200&seq=waterstop-1&orientation=landscape',
          description: 'High-quality waterstop systems for construction joints providing permanent water barrier in concrete structures.',
          applications: ['Construction joints', 'Expansion joints', 'Water retaining structures', 'Tunnels and subways', 'Dams', 'Swimming pools'],
          features: ['Permanent water barrier', 'Movement accommodation', 'Chemical resistance', 'Easy installation', 'Various profiles available', 'Long service life >50 years'],
          technicalSpecs: {
            materials: 'PVC, EPDM, Hydrophilic',
            width: '150-350mm',
            movement: '±25mm',
            waterResistance: '>15 bar'
          }
        },
        {
          name: 'Polyurethane and Polyurea Waterproofing',
          image: 'https://readdy.ai/api/search-image?query=Polyurethane%20waterproofing%20membrane%20application%2C%20spray-applied%20polyurea%20waterproofing%20system%20installation&width=300&height=200&seq=pu-water-1&orientation=landscape',
          description: 'High-performance polyurethane waterproofing systems offering seamless application and exceptional elasticity.',
          applications: ['Roofing systems', 'Parking decks', 'Bridges', 'Industrial applications', 'Sports facilities', 'Podium waterproofing'],
          features: ['Seamless application', 'Excellent elasticity >400%', 'Chemical resistance', 'Fast curing', 'UV stable', 'Abrasion resistance'],
          technicalSpecs: {
            appearance: 'Various colors',
            elongation: '>400%',
            thickness: '1.5-3.0mm',
            cureTime: '24-48 hours'
          }
        },
        {
          name: 'Hot-Applied and Sheet Waterproofing Membranes',
          image: 'https://readdy.ai/api/search-image?query=Hot-applied%20waterproofing%20membrane%20installation%2C%20torch-on%20membrane%20application%20on%20roof%20surface&width=300&height=200&seq=hot-membrane-1&orientation=landscape',
          description: 'Pre-formed and hot-applied membrane systems providing superior puncture resistance and long-term durability.',
          applications: ['Roof waterproofing', 'Foundation protection', 'Tunnel lining', 'Bridge decks', 'Plaza decks', 'Green roof systems'],
          features: ['Pre-formed quality control', 'High puncture resistance', 'Long-term durability >25 years', 'Professional installation', 'Root resistance', 'Fire resistance'],
          technicalSpecs: {
            thickness: '3-5mm',
            tensileStrength: '>800 N/50mm',
            punctureResistance: '>300N',
            serviceLife: '>25 years'
          }
        },
        {
          name: 'Ancillary Products & Accessories',
          image: 'https://readdy.ai/api/search-image?query=Waterproofing%20accessories%20and%20ancillary%20products%2C%20drainage%20systems%20and%20waterproofing%20components&width=300&height=200&seq=ancillary-1&orientation=landscape',
          description: 'Supporting products and accessories for waterproofing systems including primers, protection layers, and drainage components.',
          applications: ['System completion', 'Detail work', 'Drainage', 'Protection layers', 'Termination details', 'Penetration sealing'],
          features: ['System compatibility', 'Complete solutions', 'Quality accessories', 'Professional finish', 'Easy installation', 'Reliable performance'],
          technicalSpecs: {
            products: 'Primers, drains, outlets',
            compatibility: 'All waterproofing systems',
            materials: 'Various as per application',
            installation: 'Professional recommended'
          }
        }
      ]
    },
    {
      id: 'adhesives',
      name: 'Adhesives',
      icon: 'ri-attachment-line',
      description: 'High-performance adhesive solutions for construction applications requiring strong, reliable bonding.',
      benefits: ['Strong bonding', 'Versatile use', 'Easy application', 'Reliable performance'],
      technicalInfo: {
        compliance: 'ASTM C881, IS 13360, BS EN 1504-4',
        bondStrength: '>3.0 MPa',
        packaging: '1kg, 5kg, 25kg units',
        shelfLife: '12-24 months'
      },
      products: [
        {
          name: 'Polymer Adhesives',
          image: 'https://readdy.ai/api/search-image?query=Polymer%20adhesive%20application%20in%20construction%2C%20flexible%20construction%20adhesive%20for%20various%20materials%20bonding&width=300&height=200&seq=polymer-adh-1&orientation=landscape',
          description: 'Flexible polymer-based adhesives for bonding various substrates with excellent weather resistance and flexibility.',
          applications: ['Multi-substrate bonding', 'Flexible connections', 'Weatherproof joints', 'General construction', 'Panel bonding', 'Trim attachment'],
          features: ['Flexible bond line', 'Weather resistance', 'Multi-substrate compatibility', 'Easy application', 'Paintable surface', 'Long open time'],
          technicalSpecs: {
            appearance: 'White/grey paste',
            bondStrength: '>2.0 MPa',
            elongation: '>200%',
            temperatureRange: '-40°C to +80°C'
          }
        },
        {
          name: 'Epoxy Adhesives',
          image: 'https://readdy.ai/api/search-image?query=Structural%20epoxy%20adhesive%20bonding%20in%20construction%20application%2C%20high-strength%20construction%20adhesive%2C%20building%20material%20bonding%20system&width=300&height=200&seq=adhesive-1&orientation=landscape',
          description: 'High-strength structural adhesives for demanding applications requiring exceptional bond strength and durability.',
          applications: ['Steel to concrete bonding', 'Composite bonding', 'Structural applications', 'Anchor bolt bonding', 'Precast connections', 'Repair bonding'],
          features: ['High shear strength >15 MPa', 'Temperature resistant', 'Chemical resistance', 'Structural bonding capability', 'Gap filling properties', 'Long service life'],
          technicalSpecs: {
            appearance: 'Grey/amber paste',
            bondStrength: '>15 MPa',
            workingTime: '30-45 minutes',
            serviceTemperature: '-40°C to +120°C'
          }
        }
      ]
    },
    {
      id: 'tile-adhesives-grouts',
      name: 'Tile Adhesives & Grouts',
      icon: 'ri-layout-grid-line',
      description: 'Complete tiling solutions for ceramic and stone installations with superior adhesion and durability.',
      benefits: ['Superior adhesion', 'Water resistance', 'Easy application', 'Professional finish'],
      technicalInfo: {
        compliance: 'IS 15477, ASTM C118, BS EN 12004',
        bondStrength: '>1.0 MPa',
        packaging: '20kg, 40kg bags',
        shelfLife: '12 months in dry storage'
      },
      products: [
        {
          name: 'Ceramic Tile & Stone Adhesives',
          image: 'https://readdy.ai/api/search-image?query=Professional%20tile%20installation%20with%20high-performance%20adhesive%2C%20ceramic%20tile%20adhesive%20application%2C%20construction%20tile%20fixing%20work&width=300&height=200&seq=tile-1&orientation=landscape',
          description: 'High-performance tile fixing solutions for ceramic tiles and natural stone with excellent bond strength and water resistance.',
          applications: ['Ceramic tile installation', 'Natural stone fixing', 'Wall tiling', 'Floor tiling', 'Swimming pools', 'Exterior applications'],
          features: ['Superior bond strength >1.5 MPa', 'Water resistant formulation', 'Non-slip formula', 'Extended open time', 'Easy application', 'Suitable for large format tiles'],
          technicalSpecs: {
            appearance: 'Grey/white powder',
            bondStrength: '>1.5 MPa',
            openTime: '20-30 minutes',
            potLife: '3-4 hours'
          }
        },
        {
          name: 'Ceramic Tile & Stone Grouts',
          image: 'https://readdy.ai/api/search-image?query=Tile%20grouting%20application%20with%20professional%20grout%2C%20ceramic%20tile%20joint%20filling%2C%20construction%20tile%20finishing%20work&width=300&height=200&seq=grout-1&orientation=landscape',
          description: 'Durable grouting solutions for tile joints offering stain resistance and consistent color throughout the service life.',
          applications: ['Tile joint filling', 'Stone joint grouting', 'Wall grouting', 'Floor grouting', 'Wet area applications', 'Commercial installations'],
          features: ['Stain resistance', 'Water resistance', 'Color consistency', 'Easy cleaning', 'Mold resistance', 'Shrinkage compensated'],
          technicalSpecs: {
            appearance: 'Various colors',
            jointWidth: '2-20mm',
            compressiveStrength: '>15 MPa',
            waterAbsorption: '<5%'
          }
        },
        {
          name: 'Performance Tiling Grouts',
          image: 'https://readdy.ai/api/search-image?query=High-performance%20tile%20grout%20application%20in%20demanding%20environment%2C%20specialized%20grouting%20for%20heavy-duty%20applications&width=300&height=200&seq=perf-grout-1&orientation=landscape',
          description: 'High-performance grouts for demanding applications requiring superior chemical resistance and durability.',
          applications: ['Swimming pools', 'Commercial kitchens', 'Industrial areas', 'High-traffic zones', 'Chemical exposure areas', 'Food processing facilities'],
          features: ['Chemical resistance', 'High strength >25 MPa', 'Stain proof formulation', 'Anti-bacterial properties', 'Easy maintenance', 'Long service life'],
          technicalSpecs: {
            appearance: 'Various colors',
            chemicalResistance: 'Excellent',
            compressiveStrength: '>25 MPa',
            antibacterial: 'Yes'
          }
        },
        {
          name: 'Epoxy Adhesives & Grouts',
          image: 'https://readdy.ai/api/search-image?query=Epoxy%20tile%20adhesive%20and%20grout%20application%20for%20chemical-resistant%20installation%2C%20industrial%20tile%20fixing%20with%20epoxy%20systems&width=300&height=200&seq=epoxy-tile-1&orientation=landscape',
          description: 'Chemical-resistant epoxy systems for tiles in aggressive environments requiring maximum durability and performance.',
          applications: ['Chemical plants', 'Laboratories', 'Food processing areas', 'Industrial kitchens', 'Pharmaceutical facilities', 'Clean rooms'],
          features: ['Excellent chemical resistance', 'Non-porous surface', 'High strength >40 MPa', 'Easy maintenance', 'Hygienic surface', 'Long service life >20 years'],
          technicalSpecs: {
            appearance: 'Various colors',
            chemicalResistance: 'Excellent',
            compressiveStrength: '>40 MPa',
            porosity: 'Zero'
          }
        }
      ]
    },
    {
      id: 'building-finishing',
      name: 'Building Finishing Products',
      icon: 'ri-brush-line',
      description: 'Complete range of building finishing and plastering solutions for superior surface preparation and finishing.',
      benefits: ['Smooth finish', 'Easy application', 'Durable surface', 'Professional appearance'],
      technicalInfo: {
        compliance: 'IS 2542, ASTM C926, BS EN 998-1',
        coverage: '1.2-1.5 kg/m²/mm thickness',
        packaging: '40kg bags',
        shelfLife: '6 months in dry storage'
      },
      products: [
        {
          name: 'Block Mortars',
          image: 'https://readdy.ai/api/search-image?query=Block%20laying%20mortar%20application%20in%20construction%2C%20masonry%20mortar%20for%20block%20installation%2C%20construction%20block%20work&width=300&height=200&seq=block-mortar-1&orientation=landscape',
          description: 'Specialized mortars for block laying and masonry work providing excellent bond strength and workability.',
          applications: ['Block laying', 'Masonry construction', 'Wall construction', 'Structural masonry', 'Partition walls', 'Load-bearing walls'],
          features: ['High bond strength >0.4 MPa', 'Good workability', 'Weather resistance', 'Consistent quality', 'Easy application', 'Reduced wastage'],
          technicalSpecs: {
            appearance: 'Grey powder',
            bondStrength: '>0.4 MPa',
            compressiveStrength: '>5 MPa',
            coverage: '25-30 blocks per 40kg'
          }
        },
        {
          name: 'Key Coat and Primers',
          image: 'https://readdy.ai/api/search-image?query=Primer%20and%20key%20coat%20application%20on%20concrete%20surface%2C%20surface%20preparation%20coating%20for%20better%20adhesion&width=300&height=200&seq=primer-1&orientation=landscape',
          description: 'Surface preparation coatings and primers for improving adhesion between substrates and subsequent coatings.',
          applications: ['Surface preparation', 'Primer coats', 'Adhesion improvement', 'Base coats', 'Substrate stabilization', 'Paint preparation'],
          features: ['Better adhesion improvement', 'Surface stabilization', 'Easy brush/roller application', 'Quick drying 2-4 hours', 'Penetrating formula', 'Cost effective'],
          technicalSpecs: {
            appearance: 'Clear/white liquid',
            coverage: '8-12 m²/liter',
            dryingTime: '2-4 hours',
            recoatTime: '4-6 hours'
          }
        },
        {
          name: 'Leveling Coat Plasters',
          image: 'https://readdy.ai/api/search-image?query=Leveling%20plaster%20application%20on%20wall%20surface%2C%20smooth%20wall%20leveling%20compound%20for%20surface%20preparation&width=300&height=200&seq=level-plaster-1&orientation=landscape',
          description: 'Self-leveling plasters for surface correction and preparation providing smooth, even surfaces for final finishing.',
          applications: ['Wall leveling', 'Surface correction', 'Substrate preparation', 'Renovation work', 'Ceiling leveling', 'Interior preparation'],
          features: ['Self-leveling properties', 'Smooth finish', 'Easy trowel application', 'Quick setting 2-3 hours', 'Shrinkage compensated', 'Excellent adhesion'],
          technicalSpecs: {
            appearance: 'White powder',
            thickness: '3-15mm',
            settingTime: '2-3 hours',
            coverage: '1.3 kg/m²/mm'
          }
        },
        {
          name: 'Smooth Finishing and Filling Plasters',
          image: 'https://readdy.ai/api/search-image?query=Smooth%20finishing%20plaster%20application%20for%20final%20wall%20finish%2C%20professional%20plastering%20work%20for%20interior%20walls&width=300&height=200&seq=finish-plaster-1&orientation=landscape',
          description: 'Final finishing plasters for creating ultra-smooth surfaces ready for painting or decorative treatments.',
          applications: ['Interior finishing', 'Smooth wall surfaces', 'Decorative finishes', 'Final coats', 'Ceiling finishing', 'Premium interiors'],
          features: ['Ultra-smooth finish', 'Easy sanding', 'Paint ready surface', 'Professional quality', 'Crack resistant', 'White finish'],
          technicalSpecs: {
            appearance: 'White powder',
            thickness: '1-3mm',
            coverage: '1.2 kg/m²/mm',
            sandingTime: '12-24 hours'
          }
        }
      ]
    },
    {
      id: 'structural-strengthening',
      name: 'Structural Strengthening',
      icon: 'ri-building-2-line',
      description: 'Advanced structural strengthening and rehabilitation solutions for increasing load capacity and seismic resistance.',
      benefits: ['Increased load capacity', 'Seismic upgrading', 'Extended service life', 'Cost-effective solution'],
      technicalInfo: {
        compliance: 'ACI 440, IS 15988, BS EN 1504-4',
        strengthIncrease: '50-300% depending on application',
        packaging: 'Complete systems with accessories',
        designLife: '>50 years'
      },
      products: [
        {
          name: 'Strengthening Products',
          image: 'https://readdy.ai/api/search-image?query=Structural%20strengthening%20system%20installation%20on%20concrete%20beam%2C%20building%20reinforcement%20with%20strengthening%20materials&width=300&height=200&seq=strengthen-1&orientation=landscape',
          description: 'General structural strengthening solutions including steel plate bonding and external reinforcement systems.',
          applications: ['Building upgrades', 'Load capacity increase', 'Structural repairs', 'Seismic retrofitting', 'Bridge strengthening', 'Industrial structures'],
          features: ['Increased load capacity up to 200%', 'Easy installation', 'Cost effective solution', 'Proven technology', 'Minimal disruption', 'Long service life'],
          technicalSpecs: {
            strengthIncrease: 'Up to 200%',
            bondStrength: '>3.0 MPa',
            installation: 'External bonding',
            serviceLife: '>50 years'
          }
        },
        {
          name: 'Carbon Fiber Reinforced Systems',
          image: 'https://readdy.ai/api/search-image?query=Carbon%20fiber%20reinforcement%20installation%20on%20concrete%20beam%2C%20structural%20strengthening%20with%20CFRP%2C%20building%20reinforcement%20construction%20work&width=300&height=200&seq=carbon-fiber-1&orientation=landscape',
          description: 'Advanced composite strengthening solutions using carbon fiber reinforced polymers for maximum strength-to-weight ratio.',
          applications: ['Beam flexural strengthening', 'Column confinement', 'Slab reinforcement', 'Seismic upgrading', 'Shear strengthening', 'Historic building preservation'],
          features: ['High strength-to-weight ratio', 'Corrosion resistant', 'Easy installation', 'Minimal thickness addition', 'Excellent fatigue resistance', 'Design flexibility'],
          technicalSpecs: {
            tensileStrength: '>3500 MPa',
            elasticModulus: '>230 GPa',
            thickness: '0.17-1.4mm',
            strengthIncrease: 'Up to 300%'
          }
        }
      ]
    }
  ];

  const selectedCategoryData = productCategories.find(cat => cat.name === selectedCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Enhanced Hero Section */}
      <section 
        className="relative pt-20 overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(69, 82, 74, 0.9) 0%, rgba(52, 73, 94, 0.85) 50%, rgba(69, 82, 74, 0.9) 100%), url('https://readdy.ai/api/search-image?query=Modern%20construction%20chemical%20laboratory%20with%20advanced%20testing%20equipment%2C%20chemical%20product%20development%20facility%2C%20scientists%20working%20with%20construction%20materials%2C%20high-tech%20chemical%20manufacturing%20plant%2C%20professional%20research%20environment%20with%20safety%20equipment&width=1920&height=800&seq=products-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-32 h-32 rounded-full opacity-10 animate-pulse" style={{ backgroundColor: '#C5A365' }}></div>
          <div className="absolute top-40 right-20 w-24 h-24 rounded-full opacity-15 animate-bounce" style={{ backgroundColor: '#7E887E' }}></div>
          <div className="absolute bottom-32 left-1/4 w-20 h-20 rounded-full opacity-10 animate-ping" style={{ backgroundColor: '#10B981' }}></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
          <div className="max-w-6xl mx-auto text-center">
            {/* Hero Badge */}
            <div className="inline-flex items-center px-4 lg:px-6 py-2 lg:py-3 rounded-full border border-white/30 backdrop-blur-sm bg-white/10 text-white text-xs lg:text-sm font-medium mb-6 lg:mb-8 animate-fade-in">
              <i className="ri-flask-line mr-2 text-emerald-300"></i>
              Premium Construction Chemicals & Solutions
            </div>

            {/* Main Heading */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 lg:mb-8 text-white drop-shadow-2xl leading-tight">
              Complete Range of
              <span className="block bg-gradient-to-r from-emerald-300 via-cyan-300 to-teal-300 bg-clip-text text-transparent animate-gradient-x bg-size-200 mt-2">
                Construction Chemicals
              </span>
            </h1>
            
            <p className="text-lg lg:text-xl xl:text-2xl text-gray-100 max-w-4xl mx-auto leading-relaxed mb-8 lg:mb-12 drop-shadow-lg px-4">
              Discover our comprehensive portfolio of high-performance construction chemicals, 
              designed to meet every project requirement with superior quality and reliability.
            </p>

            {/* Key Statistics */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mb-12 lg:mb-16">
              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center backdrop-blur-sm bg-white/10 group-hover:bg-white/20 transition-all duration-300">
                  <i className="ri-product-hunt-line text-2xl lg:text-3xl text-emerald-300"></i>
                </div>
                <div className="text-2xl lg:text-4xl font-bold text-white drop-shadow-lg mb-1 lg:mb-2">150+</div>
                <div className="text-gray-200 font-medium text-sm lg:text-base">Products</div>
              </div>
              
              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center backdrop-blur-sm bg-white/10 group-hover:bg-white/20 transition-all duration-300">
                  <i className="ri-tools-line text-2xl lg:text-3xl text-cyan-300"></i>
                </div>
                <div className="text-2xl lg:text-4xl font-bold text-white drop-shadow-lg mb-1 lg:mb-2">12</div>
                <div className="text-gray-200 font-medium text-sm lg:text-base">Categories</div>
              </div>
              
              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center backdrop-blur-sm bg-white/10 group-hover:bg-white/20 transition-all duration-300">
                  <i className="ri-building-line text-2xl lg:text-3xl text-teal-300"></i>
                </div>
                <div className="text-2xl lg:text-4xl font-bold text-white drop-shadow-lg mb-1 lg:mb-2">500+</div>
                <div className="text-gray-200 font-medium text-sm lg:text-base">Projects</div>
              </div>
              
              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center backdrop-blur-sm bg-white/10 group-hover:bg-white/20 transition-all duration-300">
                  <i className="ri-shield-check-line text-2xl lg:text-3xl text-emerald-300"></i>
                </div>
                <div className="text-2xl lg:text-4xl font-bold text-white drop-shadow-lg mb-1 lg:mb-2">ISO</div>
                <div className="text-gray-200 font-medium text-sm lg:text-base">Certified</div>
              </div>
            </div>

            {/* Feature Highlights */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
              <div className="backdrop-blur-sm bg-white/10 rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 group cursor-pointer">
                <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#7E887E' }}>
                  <i className="ri-award-line text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg lg:text-xl font-semibold text-white mb-2 lg:mb-3">Premium Quality</h3>
                <p className="text-gray-200 text-xs lg:text-sm leading-relaxed">
                  International standards compliance with rigorous quality control and testing protocols.
                </p>
              </div>
              
              <div className="backdrop-blur-sm bg-white/10 rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 group cursor-pointer">
                <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#C5A365' }}>
                  <i className="ri-customer-service-2-line text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg lg:text-xl font-semibold text-white mb-2 lg:mb-3">Technical Support</h3>
                <p className="text-gray-200 text-xs lg:text-sm leading-relaxed">
                  Expert guidance, training programs, and on-site technical assistance for optimal results.
                </p>
              </div>
              
              <div className="backdrop-blur-sm bg-white/10 rounded-xl lg:rounded-2xl p-4 lg:p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 group cursor-pointer">
                <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-3 lg:mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#10B981' }}>
                  <i className="ri-truck-line text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-lg lg:text-xl font-semibold text-white mb-2 lg:mb-3">Fast Delivery</h3>
                <p className="text-gray-200 text-xs lg:text-sm leading-relaxed">
                  Nationwide distribution network ensuring quick and reliable product supply.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-4 lg:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 lg:w-8 lg:h-12 border-2 border-white/60 rounded-full flex justify-center backdrop-blur-sm">
            <div className="w-1 h-3 lg:w-1.5 lg:h-4 bg-white/80 rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* Mobile Category Toggle Button */}
      <div className="lg:hidden bg-white border-b border-gray-200 px-4 py-3">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="w-full flex items-center justify-between px-4 py-3 bg-gray-800 text-white rounded-lg"
        >
          <span className="font-medium">{selectedCategory}</span>
          <i className={`ri-arrow-${isSidebarOpen ? 'up' : 'down'}-s-line text-xl`}></i>
        </button>
      </div>

      {/* Main Product Section */}
      <section className="py-8 lg:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            
            {/* Left Sidebar - Categories */}
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-80 bg-gray-800 rounded-xl p-4 lg:p-6 shadow-2xl lg:sticky lg:top-4 lg:self-start`} style={{ minHeight: '400px' }}>
              <div className="mb-6 lg:mb-8">
                <h2 className="text-white text-xl lg:text-2xl font-bold mb-2">Product Categories</h2>
                <div className="w-12 h-1 rounded" style={{ backgroundColor: '#C5A365' }}></div>
              </div>
              <div className="space-y-2 lg:space-y-3 max-h-96 lg:max-h-none overflow-y-auto">
                {productCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.name);
                      setIsSidebarOpen(false);
                    }}
                    className={`w-full text-left px-3 lg:px-5 py-3 lg:py-4 rounded-lg lg:rounded-xl transition-all duration-300 flex items-center space-x-3 lg:space-x-4 cursor-pointer group hover:scale-105 ${
                      selectedCategory === category.name 
                        ? 'text-white shadow-lg transform scale-105' 
                        : 'text-gray-300 hover:text-white hover:bg-gray-700'
                    }`}
                    style={{
                      backgroundColor: selectedCategory === category.name ? '#C5A365' : 'transparent'
                    }}
                  >
                    <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                      backgroundColor: selectedCategory === category.name ? 'rgba(255,255,255,0.2)' : 'rgba(197,163,101,0.1)'
                    }}>
                      <i className={`${category.icon} text-sm lg:text-lg`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs lg:text-sm font-semibold truncate">{category.name}</div>
                      <div className="text-xs opacity-75 truncate">
                        {category.products.length} Products
                      </div>
                    </div>
                    <i className="ri-arrow-right-s-line text-lg group-hover:translate-x-1 transition-transform hidden lg:block"></i>
                  </button>
                ))}
              </div>
            </div>

            {/* Right Content - Products */}
            <div className="flex-1">
              {selectedCategoryData && (
                <div>
                  {/* Category Header */}
                  <div className="mb-8 lg:mb-10">
                    <div className="flex flex-col lg:flex-row lg:items-start space-y-4 lg:space-y-0 lg:space-x-6 mb-6">
                      <div className="w-12 h-12 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                        <i className={`${selectedCategoryData.icon} text-2xl lg:text-3xl`} style={{ color: '#7E887E' }}></i>
                      </div>
                      <div className="flex-1">
                        <h2 className="text-2xl lg:text-4xl font-bold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>
                          {selectedCategoryData.name}
                        </h2>
                        <p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-3 lg:mb-4">
                          {selectedCategoryData.description}
                        </p>
                        <div className="flex flex-wrap gap-2 lg:gap-3">
                          {selectedCategoryData.benefits.map((benefit, index) => (
                            <span 
                              key={index}
                              className="inline-flex items-center px-2 lg:px-3 py-1 rounded-full text-xs lg:text-sm font-medium text-white"
                              style={{ backgroundColor: '#7E887E' }}
                            >
                              <i className="ri-check-line mr-1"></i>
                              {benefit}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="w-16 lg:w-20 h-1 rounded" style={{ backgroundColor: '#C5A365' }}></div>
                  </div>

                  {/* Technical Information Panel */}
                  <div className="bg-white rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-lg border border-gray-100 mb-8 lg:mb-10">
                    <h3 className="text-lg lg:text-xl font-bold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>Technical Information</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
                      <div>
                        <div className="text-xs lg:text-sm text-gray-600 mb-1">Standards Compliance</div>
                        <div className="font-semibold text-gray-800 text-sm lg:text-base">{selectedCategoryData.technicalInfo.compliance}</div>
                      </div>
                      <div>
                        <div className="text-xs lg:text-sm text-gray-600 mb-1">Packaging</div>
                        <div className="font-semibold text-gray-800 text-sm lg:text-base">{selectedCategoryData.technicalInfo.packaging}</div>
                      </div>
                      <div>
                        <div className="text-xs lg:text-sm text-gray-600 mb-1">Shelf Life</div>
                        <div className="font-semibold text-gray-800 text-sm lg:text-base">{selectedCategoryData.technicalInfo.shelfLife}</div>
                      </div>
                      <div>
                        <div className="text-xs lg:text-sm text-gray-600 mb-1">
                          {selectedCategoryData.technicalInfo.dosage ? 'Dosage' : 
                           selectedCategoryData.technicalInfo.coverage ? 'Coverage' : 
                           selectedCategoryData.technicalInfo.compressiveStrength ? 'Strength' : 
                           selectedCategoryData.technicalInfo.bondStrength ? 'Bond Strength' : 
                           selectedCategoryData.technicalInfo.wearResistance ? 'Wear Resistance' : 
                           selectedCategoryData.technicalInfo.serviceLife ? 'Service Life' : 
                           selectedCategoryData.technicalInfo.movementCapability ? 'Movement' : 
                           selectedCategoryData.technicalInfo.waterResistance ? 'Water Resistance' : 
                           selectedCategoryData.technicalInfo.strengthIncrease ? 'Strength Increase' : 'Performance'}
                        </div>
                        <div className="font-semibold text-gray-800 text-sm lg:text-base">
                          {selectedCategoryData.technicalInfo.dosage || 
                           selectedCategoryData.technicalInfo.coverage || 
                           selectedCategoryData.technicalInfo.compressiveStrength ||
                           selectedCategoryData.technicalInfo.bondStrength ||
                           selectedCategoryData.technicalInfo.wearResistance ||
                           selectedCategoryData.technicalInfo.serviceLife ||
                           selectedCategoryData.technicalInfo.movementCapability ||
                           selectedCategoryData.technicalInfo.waterResistance ||
                           selectedCategoryData.technicalInfo.strengthIncrease || 'High Performance'}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Products Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-8 mb-8 lg:mb-12" data-product-shop>
                    {selectedCategoryData.products.map((product, index) => (
                      <div key={index} className="bg-white rounded-xl lg:rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group" data-product-shop>
                        <div className="aspect-[4/3] overflow-hidden">
                          <img 
                            src={product.image}
                            alt={product.name}
                            className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                          />
                        </div>
                        <div className="p-4 lg:p-6">
                          <h3 className="text-lg lg:text-xl font-bold mb-2 lg:mb-3 group-hover:text-emerald-600 transition-colors" style={{ color: '#7E887E' }}>
                            {product.name}
                          </h3>
                          <p className="text-gray-600 text-xs lg:text-sm leading-relaxed mb-3 lg:mb-4">
                            {product.description}
                          </p>
                          
                          {/* Applications */}
                          <div className="mb-3 lg:mb-4">
                            <h4 className="text-xs lg:text-sm font-semibold text-gray-800 mb-2">Applications:</h4>
                            <div className="flex flex-wrap gap-1">
                              {product.applications.slice(0, 3).map((app, appIndex) => (
                                <span 
                                  key={appIndex}
                                  className="text-xs px-2 py-1 rounded-full text-gray-600"
                                  style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}
                                >
                                  {app}
                                </span>
                              ))}
                              {product.applications.length > 3 && (
                                <span 
                                  className="text-xs px-2 py-1 rounded-full text-gray-600"
                                  style={{ backgroundColor: 'rgba(197, 163, 101, 0.1)' }}
                                >
                                  +{product.applications.length - 3} more
                                </span>
                              )}
                            </div>
                          </div>

                          {/* Key Features */}
                          <div className="mb-3 lg:mb-4">
                            <h4 className="text-xs lg:text-sm font-semibold text-gray-800 mb-2">Key Features:</h4>
                            <ul className="space-y-1">
                              {product.features.slice(0, 3).map((feature, featureIndex) => (
                                <li key={featureIndex} className="flex items-start text-xs text-gray-600">
                                  <i className="ri-check-line text-green-500 mr-1 mt-0.5 flex-shrink-0"></i>
                                  <span>{feature}</span>
                                </li>
                              ))}
                            </ul>
                          </div>

                          {/* Technical Specifications */}
                          <div className="bg-gray-50 rounded-lg p-3 mb-3 lg:mb-4">
                            <h4 className="text-xs font-semibold text-gray-800 mb-2">Technical Specs:</h4>
                            <div className="space-y-1">
                              {Object.entries(product.technicalSpecs).slice(0, 2).map(([key, value], specIndex) => (
                                <div key={specIndex} className="flex justify-between text-xs">
                                  <span className="text-gray-600 capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}:</span>
                                  <span className="font-medium text-gray-800">{value}</span>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Product Badge */}
                          <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                              <div className="w-3 h-3 rounded-full bg-green-500"></div>
                              <span className="text-xs text-gray-600">In Stock</span>
                            </div>
                            <div className="text-xs text-gray-500">
                              <i className="ri-shield-check-line mr-1"></i>
                              ISO Certified
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Enhanced Category Info */}
                  <div className="bg-white rounded-xl lg:rounded-2xl p-6 lg:p-8 shadow-lg border border-gray-100">
                    <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-start">
                      <div>
                        <div className="flex items-center mb-4 lg:mb-6">
                          <div className="w-12 h-12 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0 mr-3 lg:mr-4" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                            <i className={`${selectedCategoryData.icon} text-2xl lg:text-3xl`} style={{ color: '#7E887E' }}></i>
                          </div>
                          <h3 className="text-xl lg:text-2xl font-bold" style={{ color: '#7E887E' }}>
                            Why Choose Our {selectedCategoryData.name}?
                          </h3>
                        </div>
                        
                        <div className="space-y-3 lg:space-y-4">
                          <div className="flex items-start space-x-3 lg:space-x-4">
                            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)' }}>
                              <i className="ri-shield-check-line text-green-600 text-sm lg:text-lg"></i>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Quality Assured</h4>
                              <p className="text-gray-600 text-xs lg:text-sm">Rigorously tested to international standards with comprehensive quality control measures and third‑party certifications.</p>
                            </div>
                          </div>
                          
                          <div className="flex items-start space-x-3 lg:space-x-4">
                            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                              <i className="ri-customer-service-2-line text-sm lg:text-lg" style={{ color: '#7E887E' }}></i>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Expert Support</h4>
                              <p className="text-gray-600 text-xs lg:text-sm">Dedicated technical team providing application guidance, training programs, and on‑site troubleshooting support.</p>
                            </div>
                          </div>
                          
                          <div className="flex items-start space-x-3 lg:space-x-4">
                            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(168, 85, 247, 0.1)' }}>
                              <i className="ri-truck-line text-purple-600 text-sm lg:text-lg"></i>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Reliable Supply</h4>
                              <p className="text-gray-600 text-xs lg:text-sm">Extensive distribution network with strategic warehouses ensuring timely delivery across all regions and emergency supply capability.</p>
                            </div>
                          </div>

                          <div className="flex items-start space-x-3 lg:space-x-4">
                            <div className="w-8 h-8 lg:w-10 lg:h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(197, 163, 101, 0.1)' }}>
                              <i className="ri-award-line text-sm lg:text-lg" style={{ color: '#C5A365' }}></i>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Proven Performance</h4>
                              <p className="text-gray-600 text-xs lg:text-sm">Over 25 years of successful project implementations with documented case studies and performance data from major infrastructure projects.</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-4 lg:space-y-6">
                        <div className="bg-gray-50 rounded-xl p-4 lg:p-6">
                          <h4 className="text-base lg:text-lg font-semibold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>Category Specifications</h4>
                          <ul className="space-y-2 lg:space-y-3">
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Standards Compliance:</span>
                              <span className="font-medium">{selectedCategoryData.technicalInfo.compliance}</span>
                            </li>
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Quality Certification:</span>
                              <span className="font-medium">ISO 9001:2015</span>
                            </li>
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Environmental:</span>
                              <span className="font-medium">Green Building Compliant</span>
                            </li>
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Technical Support:</span>
                              <span className="font-medium">24/7 Available</span>
                            </li>
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Training Programs:</span>
                              <span className="font-medium">Included</span>
                            </li>
                            <li className="flex justify-between text-xs lg:text-sm">
                              <span className="text-gray-600">Warranty:</span>
                              <span className="font-medium">Performance Guaranteed</span>
                            </li>
                          </ul>
                        </div>

                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 lg:p-6">
                          <h4 className="text-base lg:text-lg font-semibold mb-2 lg:mb-3" style={{ color: '#7E887E' }}>Application Support</h4>
                          <ul className="space-y-1 lg:space-y-2 text-xs lg:text-sm text-gray-700">
                            <li className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-2"></i>
                              Pre‑application consultation and site assessment
                            </li>
                            <li className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-2"></i>
                              Detailed application guidelines and procedures
                            </li>
                            <li className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-2"></i>
                              On‑site technical supervision available
                            </li>
                            <li className="flex items-center">
                              <i className="ri-check-line text-green-500 mr-2"></i>
                              Post‑application performance monitoring
                            </li>
                          </ul>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-3 lg:gap-4">
                          <button 
                            className="flex-1 text-white px-4 lg:px-6 py-2 lg:py-3 rounded-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap hover:shadow-lg text-sm lg:text-base"
                            style={{ backgroundColor: '#7E887E' }}
                          >
                            <i className="ri-download-line mr-2"></i>
                            Download Catalog
                          </button>
                          <button 
                            className="flex-1 border-2 px-4 lg:px-6 py-2 lg:py-3 rounded-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap hover:shadow-lg text-sm lg:text-base"
                            style={{ borderColor: '#C5A365', color: '#C5A365' }}
                          >
                            <i className="ri-customer-service-2-line mr-2"></i>
                            Technical Support
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Additional Content Section */}
      <section className="py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 lg:mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-4 lg:mb-6" style={{ color: '#7E887E' }}>
                Complete Construction Chemical Solutions
              </h2>
              <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
                From concept to completion, we provide comprehensive chemical solutions that ensure project success and long‑term durability.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12 lg:mb-16">
              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                  <i className="ri-microscope-line text-2xl lg:text-3xl" style={{ color: '#7E887E' }}></i>
                </div>
                <h3 className="text-lg lg:text-xl font-bold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>Research & Development</h3>
                <p className="text-gray-600 leading-relaxed text-sm lg:text-base">
                  Continuous innovation in chemical formulations to meet evolving construction industry requirements with cutting‑edge laboratory facilities.
                </p>
              </div>

              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: 'rgba(197, 163, 101, 0.1)' }}>
                  <i className="ri-test-tube-line text-2xl lg:text-3xl" style={{ color: '#C5A365' }}></i>
                </div>
                <h3 className="text-lg lg:text-xl font-bold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>Quality Testing</h3>
                <p className="text-gray-600 leading-relaxed text-sm lg:text-base">
                  State‑of‑the‑art laboratory facilities ensuring every product meets the highest quality standards with comprehensive testing protocols.
                </p>
              </div>

              <div className="text-center group cursor-pointer">
                <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)' }}>
                  <i className="ri-settings-3-line text-2xl lg:text-3xl text-green-600"></i>
                </div>
                <h3 className="text-lg lg:text-xl font-bold mb-3 lg:mb-4" style={{ color: '#7E887E' }}>Custom Solutions</h3>
                <p className="text-gray-600 leading-relaxed text-sm lg:text-base">
                  Tailored chemical formulations designed to address specific project challenges and requirements with expert consultation.
                </p>
              </div>
            </div>

            {/* Industry Applications */}
            <div className="bg-gray-50 rounded-xl lg:rounded-2xl p-6 lg:p-8 mb-12 lg:mb-16">
              <h3 className="text-2xl lg:text-3xl font-bold text-center mb-6 lg:mb-8" style={{ color: '#7E887E' }}>
                Industry Applications
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
                <div className="text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-2 lg:mb-3 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}>
                    <i className="ri-building-line text-xl lg:text-2xl" style={{ color: '#7E887E' }}></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Commercial Buildings</h4>
                  <p className="text-xs text-gray-600">Office complexes, shopping malls, hotels</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-2 lg:mb-3 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(197, 163, 101, 0.1)' }}>
                    <i className="ri-home-4-line text-xl lg:text-2xl" style={{ color: '#C5A365' }}></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Residential Projects</h4>
                  <p className="text-xs text-gray-600">Apartments, villas, housing complexes</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-2 lg:mb-3 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)' }}>
                    <i className="ri-road-map-line text-xl lg:text-2xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Infrastructure</h4>
                  <p className="text-xs text-gray-600">Bridges, tunnels, highways, airports</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-2 lg:mb-3 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'rgba(168, 85, 247, 0.1)' }}>
                    <i className="ri-factory-line text-xl lg:text-2xl text-purple-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-1 text-sm lg:text-base">Industrial</h4>
                  <p className="text-xs text-gray-600">Manufacturing plants, warehouses</p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="text-center bg-gray-50 rounded-xl lg:rounded-2xl p-8 lg:p-12">
              <h3 className="text-2xl lg:text-3xl font-bold mb-4 lg:mb-6" style={{ color: '#7E887E' }}>
                Ready to Start Your Project?
              </h3>
              <p className="text-lg lg:text-xl text-gray-600 mb-6 lg:mb-8 max-w-2xl mx-auto">
                Get expert consultation and customized chemical solutions for your construction needs with our experienced technical team.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center">
                <button 
                  className="px-6 lg:px-8 py-3 lg:py-4 text-base lg:text-lg font-semibold text-white rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap hover:shadow-lg transform hover:scale-105"
                  style={{ backgroundColor: '#7E887E' }}
                >
                  <i className="ri-phone-line mr-2"></i>
                  Get Expert Consultation
                </button>
                <button 
                  className="px-6 lg:px-8 py-3 lg:py-4 text-base lg:text-lg font-semibold border-2 rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap hover:shadow-lg transform hover:scale-105"
                  style={{ borderColor: '#C5A365', color: '#C5A365' }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#C5A365';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#C5A365';
                  }}
                >
                  <i className="ri-download-line mr-2"></i>
                  Download Catalog
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
